import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {RmErrorStateMatcher} from '../../../utils/validators/rm-error-state-matcher';
import {environment} from '../../../../environments/environment';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {RmNormalizadorService} from '../../services/rm-normalizador.service';
import { getNameStreet, onChangeZip, searchRoadType } from 'src/app/utils/normalizerFunctions';
import { RmGlobals } from '../../classes/rm-globals';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-normaliza-direccion',
    templateUrl: './rm-normaliza-direccion.component.html',
    styleUrls: ['./rm-normaliza-direccion.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmNormalizaDireccionComponent implements OnInit, OnDestroy {
    @Input() formGroup: FormGroup;
    @ViewChild('manualAddress') manualAddress;
    @ViewChild('manualAddressText') manualAddressText;
    @ViewChild('formNumber') formNumber: ElementRef;

    public address: string;
    public isLoading = false;
    public muestraBoton = true;
    public textDefault = 'Normaliza dirección';
    public roadTypes: any[];
    public provinces: any[];
    public msgErrorPeticion: string;
    public muestraErrorPeticion = false;
    public country = environment.googleMapsCountry;
    public matcher = new RmErrorStateMatcher();
    private allSubscription: Subscription[] = [];

    constructor(
        private rmService: RepublicaMovilService,
        private normalizadorService: RmNormalizadorService,
        private rmGlobals : RmGlobals
    ) { }

    ngOnInit(): void {
        this.formGroup.enable();
        this.formGroup.get('provinciaNormaliza').disable();

        this.allSubscription.push(this.rmService.getCommonRoadTypes()
            .subscribe((data: any) => {
                if (data != null) {
                    this.roadTypes = data;
                }
            })
        );

        this.allSubscription.push(this.rmService.getProvincesAmena()
            .subscribe((data: any) => {
                if (data && !this.provinces) {
                    this.provinces = data;
                }
            })
        );

        this.allSubscription.push(this.normalizadorService.getMuestraBotonNormalizacion()
            .subscribe(data => {
                this.muestraBoton = data;
            })
        );

        if (this.formGroup.get('codigoPostalNormaliza').value != null && this.formGroup.get('codigoPostalNormaliza').value !== '') {
            this.onChangeZip(this.formGroup.get('codigoPostalNormaliza').value);
        }
    }

    onAutocompleteSelected($event) {
        const addressComponents: any[] = $event.address_components;

        if (addressComponents != null && addressComponents.length > 0) {
            this.formGroup.get('tipoViaNormaliza').patchValue('');
            this.formGroup.get('nombreViaNormaliza').patchValue('');
            this.formGroup.get('numeroNormaliza').patchValue('');
            this.formGroup.get('codigoPostalNormaliza').patchValue('');
            this.formGroup.get('localidadNormaliza').patchValue('');
            this.formGroup.get('provinciaNormaliza').patchValue('');

            for (const addressComponent of addressComponents) {
                let field = '';
                const types: string[] = addressComponent.types;
                let value: string = addressComponent.long_name;

                if (types.includes('route')) {
                    field = 'nombreViaNormaliza';
                    value = searchRoadType(value, this.roadTypes, 'code', this.formGroup.get('tipoViaNormaliza'));
                } else if (types.includes('street_number')) {
                    field = 'numeroNormaliza';
                } else if (types.includes('postal_code')) {
                    field = 'codigoPostalNormaliza';
                    this.onChangeZip(value);
                } else if (types.includes('locality')) {
                    field = 'localidadNormaliza';
                } else if (types.includes('administrative_area_level_2')) {
                    field = 'provinciaNormaliza';
                    value = value.toUpperCase();
                }

                if (field !== '') {
                    this.formGroup.get(field).patchValue(value);
                }
            }
        }
        if (this.formGroup.get('numeroNormaliza').value === '') {
            this.formNumber.nativeElement.focus();
        }
    }

    onChangeZip(value) {
        onChangeZip(value, this.provinces, 'postal_code', this.formGroup.get('provinciaNormaliza'));
    }

    onNormalizarDireccion() {
        this.muestraErrorPeticion = false;
        this.msgErrorPeticion = null;
        this.formGroup.markAllAsTouched();
        this.formGroup.updateValueAndValidity();

        if (!this.formGroup.get('tipoViaNormaliza').value || this.formGroup.get('tipoViaNormaliza').value === '') {
            searchRoadType(this.formGroup.get('nombreViaNormaliza').value, this.roadTypes, 'code', this.formGroup.get('tipoViaNormaliza'));
        }

        if (this.formGroup.valid) {
            this.onChangeLoading(true);
            this.formGroup.disable();

            this.normalizadorService.normalizarHorizontal(this.getDataNormalizar())
                .subscribe((data: any) => {
                    if (data.msg) {
                        data = data.msg;
                    }
                    if (Array.isArray(data) && data.length > 0) {
                        this.muestraErrorPeticion = false;
                        this.normalizadorService.setMuestraBotonNormalizacion(false);
                        this.normalizadorService.setMuestraCobertura(true);
                        this.normalizadorService.setDatosNormalizacion(data);
                        this.normalizadorService.setLocalidades(data);
                        this.normalizadorService.setFormularioNormalizacion(this.formGroup);
                        this.onChangeLoading(false);
                    } else {
                        this.muestraErrorPeticion = true;
                        this.msgErrorPeticion = data ? data : 'No existen resultados para los datos indicados.';
                        this.onChangeLoading(false);
                        this.formGroup.enable();
                        this.formGroup.get('provinciaNormaliza').disable();
                    }
                }, error => {
                    this.muestraErrorPeticion = true;
                    this.msgErrorPeticion = error.error.error.msg;
                    // this.msgErrorPeticion = 'No hay conectividad con los servidores de Orange.';
                    this.onChangeLoading(false);
                    this.formGroup.enable();
                    this.formGroup.get('provinciaNormaliza').disable();

                    console.error(error);
                });
        }
    }

    onChangeLoading(state) {
        if (state === true) {
            this.isLoading = true;
            this.textDefault = 'Normalizando ...';
        } else {
            this.isLoading = false;
            this.textDefault = 'Normalizar dirección';
        }
    }

    // Formateamos los datos para enviarlos al servicio
    getDataNormalizar() {
        return {
            streetNr: `${this.formGroup.value.numeroNormaliza}`,
            streetName: getNameStreet(this.formGroup.value.nombreViaNormaliza, this.roadTypes, 'code'),
            city: this.formGroup.value.localidadNormaliza,
            stateOrProvince: this.formGroup.value.provinciaNormaliza,
            streetType: this.rmGlobals.getTypeStreet(this.formGroup.value.tipoViaNormaliza, this.roadTypes),
            postCode: `${this.formGroup.value.codigoPostalNormaliza}`
        };
    }

    onAddressChange(event) {
        setTimeout(() => {
            const text = event.target.value;
            const autocompleteBoxes = document.getElementsByClassName('pac-container pac-logo');
            let autocompleteBox = autocompleteBoxes[autocompleteBoxes.length - 1];

            for (let i = 0; i < autocompleteBoxes.length; i++) {
                if (autocompleteBoxes.item(i).clientWidth > 0 && autocompleteBoxes.item(i).innerHTML) {
                    autocompleteBox = autocompleteBoxes.item(i);
                    break;
                }
            }

            if (text && text !== '') {
                this.manualAddress.nativeElement.style.display = 'flex';
                this.manualAddress.nativeElement.style.top = 'calc(100% + ' + (autocompleteBox.clientHeight - 20) + 'px)';
                this.manualAddressText.nativeElement.innerText = text;
            } else {
                this.onAddressFocusOut();
            }
        }, 300)
    }

    onAddressFocusOut() {
        setTimeout(() => {
            this.manualAddress.nativeElement.style.display = 'none';
            this.manualAddress.nativeElement.style.top = '100%';
            this.manualAddressText.nativeElement.innerText = '';
        }, 100)
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
